import {PropsWithChildren} from 'react';
import {useProfiles} from '../../api/User/useProfiles';
import {isAdmin} from '../../user/user-utils';

export default function AdminAuthContainer({children}: PropsWithChildren) {
  const {currentProfile} = useProfiles();

  if (!isAdmin(currentProfile)) {
    return <div>Insufficient permissions</div>;
  }

  return <>{children}</>;
}
